import { Component } from '@theme/component';
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];
  connectedCallback() {
    super.connectedCallback();
    const { videoSources: videoSources, videoElement: videoElement } =
      this.refs;
    for (const source of videoSources) {
      const { videoSource: videoSource } = source.dataset;
      if (videoSource) source.setAttribute('src', videoSource);
    }
    videoElement.load();
  }
}
if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
